import client from './client';
import { _createAlert } from './apiUtils';
import { Comment } from '../interfaces/CommentInterface';

// Function to get comments for a pay period
export const getCommentsForPayPeriod = async (payPeriodID: number): Promise<Comment[]> => {
    try {
        // Make the API request to fetch comments for the pay period
        const response = await client.get('/admin/comments', {
            params: {
                payPeriodID: payPeriodID
            }
        });

        // Log the response data to the console
        console.log('Comments response:', response.data);

        // Return the response data
        return response.data || [];

    } catch (error: any) {
        // Log any errors that occur during the fetch process
        console.error('Error fetching comments:', error);
        
        // Trigger an alert with the error message
        _createAlert('Error fetching comments:', error.message || 'Unknown error occurred');
        
        // Throw an error to indicate that fetching failed
        throw new Error('Failed to fetch comments');
    }
};
